import {
  useResendInviteMutation,
  ResendInviteMutationVariables,
} from "@/features/people/graphql/generated";
import { useToast } from "@/shared/contexts/toast.context";

export const useResendInvite = () => {
  const [mutate, { data, loading, error }] = useResendInviteMutation();
  const { showToast } = useToast();

  const handleResendInvite = async (
    variables: ResendInviteMutationVariables
  ) => {
    const response = await mutate({ variables });
    if (response.data?.resendInvite) {
      showToast({
        type: "success",
        message: "Invite sent successfully",
      });
    }
    return response;
  };

  return { handleResendInvite, loading, error };
};
